import React from 'react';
import { Box, Typography, Avatar, useTheme } from '@mui/material';
import starSvg from './4-5-stars.svg'; // Asegúrate de tener star.svg en la misma carpeta

/**
 * Props:
 *  - description: string
 *  - name: string
 *  - title: string
 *  - image: string (URL o import)
 */
const TestimonialCard = ({ description, name, title, image }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        // maxWidth: 400,
        bgcolor: '#fffded',
        border: `1px solid #d2c02a`,
        borderRadius: 2,
        p: 3,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
        <Box
          component="img"
          src={starSvg}
          alt="full star"
          sx={{
            width: '160px',
            // height: '15px',
            // mr: i < 3 ? '4px' : 0,
          }}
        />
      </Box>

      {/* Descripción */}
      <Typography
        variant="body1"
        sx={{ color: 'text.primary', fontSize: {xxs: '14', xs: '18px'}, mb: 2, lineHeight: 1.4 }}
      >
        {description}
      </Typography>

      {/* Cliente */}
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Avatar src={image} alt={name} sx={{ width: 50, height: 50, mr: 2 }} />
        <Box>
          <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
            {name}
          </Typography>
          <Typography sx={{ color: 'rgb(46, 59, 86)', fontSize: '14px' }}>
            {title}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default TestimonialCard;
